import type { Seo } from '@/entities/seo/models';
import type { Seo as EncodedSeo } from '@/shared/api/experience';

export const normalizeSeo = (encoded: EncodedSeo): Seo => {
  return {
    attachments: encoded.attachments,
    canonicalUrl: encoded.canonical_url,
    description: encoded.description,
    h1: encoded.h1,
    h2: encoded.h2,
    noindex: encoded.noindex,
    slug: encoded.slug,
    text: encoded.text,
    title: encoded.title,
  };
};
